import type { BoggleBadgeCheck } from '../checkTypes'
import { isAcceptedWordEntry } from '../checkTypes'
import { isFourTilesInA2x2Square } from '../wordAnalysis'

export const squareCheck: BoggleBadgeCheck = (ledger, index) => {
  const entry = ledger[index]
  return isAcceptedWordEntry(entry) && isFourTilesInA2x2Square(entry.path)
}
